<template>
  <input
    class="input"
    ref="input"
    :type="type"
    v-model="computedValue"
    @focus="handleFocus"
    @input="handleInput"
    @change="handleChange"
    @blur="handleBlur"
    @paste="handlePaste"
    :placeholder="placeholderText"
    :maxlength="maxLength"
  />
</template>

<script>
import Cleave from 'cleave.js';

export default {
  name: 'CustomInput',
  props: {
    selectonfocus: {
      type: String,
    },
    maxlength: {
      type: Number,
    },
    placeholder: {
      type: [Number, String],
      default: '',
    },
    value: [Number, String],
    type: {
      type: String,
      default: 'text',
    },
    mask: {
      type: Object,
      default: function dflt() {
        return {
          delimiter: ' ',
          numericOnly: false,
        };
      },
    },
  },
  data() {
    return {
      selectWhenFocusing: this.selectonfocus,
      maxLength: this.maxlength,
      placeholderText: this.placeholder,
      cleave: null,
      localValue: this.value,
      lastKeyPressed: null,
      length: null,
      maximumLength: null,
    };
  },
  mounted() {
    this.initializeCleave();
  },
  methods: {
    initializeCleave: function init() {
      const inputElement = this.$refs.input;
      const data = {
        ...this.mask,
        onValueChanged: (e) => {
          this.eventValueChanged(e);
        },
      };
      this.cleave = new Cleave(inputElement, data);
      this.calculateMaxLength();
      // this.$refs.input.addEventListener('keydown', (event) => {
      //   this.handleKeyDown(event);
      // });

      this.$once('hook:beforeDestroy', function beforeDestroy() {
        this.cleave.destroy();
      });
    },
    calculateMaxLength() {
      if (this.mask.numeral) {
        let delimiterThousands = 0;
        if (this.mask.numeralIntegerScale) {
          delimiterThousands = Math.round(this.mask.numeralIntegerScale / 3) - 1;
        }
        this.maximumLength = delimiterThousands
          + (this.mask.prefix ? this.mask.prefix.length : 0)
          + this.mask.numeralDecimalScale
          + this.mask.numeralIntegerScale
          + (this.mask.numeralDecimalScale ? 1 : 0)
          + (!this.mask.numeralPositiveOnly ? 1 : 0);
        this.maxLength = this.maximumLength;
      }
    },
    handleKeyDown(event) {
      this.lastKeyPressed = event.key;
      // if (this.lastKeyPressed === '.' && this.mask.numeral === true) {
      //   this.$refs.input.maxLength = this.$refs.input.maxLength + 1;
      // }
    },
    eventValueChanged(e) {
      // const inputElement = this.$refs.input;
      const { value: formattedValue, rawValue: initialRawValue } = e.target;
      const rawValue = this.mask.prefix
        ? initialRawValue.replace(this.mask.prefix, '') : initialRawValue;

      // if (rawValue.length > this.maximumLength) {
      //   return;
      // }

      // if ((this.mask.prefix !== '') && (this.mask.numeralPositiveOnly === false)
      //   && (this.mask.signBeforePrefix === true)) { rawValue = initialRawValue; }
      this.$emit('input', formattedValue);
      this.$emit('getRawValue', rawValue);

      this.length = rawValue;
      // this.maximumLength = rawValue.length;
      // if (this.lastKeyPressed === 'Backspace') {}
      // if (this.maxLength >= formattedValue.length) {}
      // const cursorPosition = inputElement.selectionStart;

      // if (formattedValue.endsWith(this.mask.prefix) && (this.mask.tailPrefix === true)
      // && (cursorPosition >= formattedValue.length - 1)) {
      //   const backTo = formattedValue.length - 1;
      //   inputElement.setSelectionRange(backTo, backTo);
      // }
    },
    handleFocusWithPrefix(prefix) {
      const inputElement = this.$refs.input;
      const prefixPosition = inputElement.value.indexOf(prefix);
      if (prefixPosition !== -1) {
        if (prefixPosition + prefix.length === inputElement.value.length) {
          inputElement.setSelectionRange(0, prefixPosition);
        } else {
          inputElement.setSelectionRange(prefixPosition + prefix.length, inputElement.value.length);
        }
      } else {
        inputElement.setSelectionRange(0, inputElement.value.length);
      }
    },
    handleFocus() {
      this.$emit('focus');
      if (this.selectWhenFocusing) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.selectWhenFocusing === 'withoutPrefix') {
              this.handleFocusWithPrefix.call(this, this.mask.prefix);
            } else {
              this.$refs.input.select();
            }
          }, 20);
        });
      }
    },
    handleInput() {},
    handleChange() {
      this.$emit('change');
    },
    handleBlur() {
      this.$emit('blur');
    },
    handlePaste(event) {
      this.$emit('paste', event);
    },
  },
  computed: {
    computedValue: {
      get() {
        if (this.localValue === this.mask.prefix) {
          return '';
        }
        return this.localValue;
      },
      set(newValue) {
        return newValue;
      },
    },
  },
  watch: {
    value(newValue) {
      if (this.localValue !== newValue) {
        this.localValue = newValue;
      }
    },
  },
};
</script>
